/**
 * 获取用户信息
 * */
import api from 'apis'

export default {
    namespaced: true,
    state: {
        hasGetInfo: false
    },
    mutations: {
        setHasGetInfo (state, status) {
            state.hasGetInfo = status
        }
    },

    actions: {
        authCheckTioPermission ({ commit, dispatch }) {
            return new Promise((resolve, reject) => {
                // 开始请求用户权限接口
                api.authCheckTioPermission({ mobile: 13698779970 })
                    .then(async res => {
                        // 设置 vuex 用户信息

                        await dispatch('user/set', { permission: res.data }, { root: true });
                        // 用户登录后从持久化数据加载一系列的设置
                        await dispatch('load');
                        // 结束
                        resolve();
                    })
                    .catch(err => {
                        // console.log('err: ', err);
                        reject(err);
                    })
            })
        },

        /**
         * @description 用户登录后从持久化数据加载一系列的设置
         * @param {Object} state vuex state
         * @param {Object} dispatch vuex dispatch
         */
        load ({ state, dispatch }) {
            return new Promise(async resolve => {
                // 加载用户登录信息
                await dispatch('user/load', null, { root: true });

                resolve();
            })
        }
    }
};
